/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ thing: NonNullable<unknown> }} Share_Volume_MonthInputs */

const en_us2_share_volume_month = /** @type {(inputs: Share_Volume_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`I lifted ${i?.thing} this month.`)
};

const pt_br2_share_volume_month = /** @type {(inputs: Share_Volume_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Levantei ${i?.thing} neste mês.`)
};

const es_419_share_volume_month = /** @type {(inputs: Share_Volume_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Levanté ${i?.thing} este mes.`)
};

const pt_pt2_share_volume_month = /** @type {(inputs: Share_Volume_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Levantei ${i?.thing} este mês.`)
};

const fr_fr2_share_volume_month = /** @type {(inputs: Share_Volume_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`J'ai soulevé ${i?.thing} ce mois-ci.`)
};

const de_de2_share_volume_month = /** @type {(inputs: Share_Volume_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Diesen Monat habe ich ${i?.thing} gestemmt.`)
};

const it_it2_share_volume_month = /** @type {(inputs: Share_Volume_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Questo mese ho sollevato ${i?.thing}.`)
};

/**
* | output |
* | --- |
* | "I lifted {thing} this month." |
*
* @param {Share_Volume_MonthInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const share_volume_month = /** @type {((inputs: Share_Volume_MonthInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Volume_MonthInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_share_volume_month(inputs)
	if (locale === "es-419") return es_419_share_volume_month(inputs)
	if (locale === "pt-PT") return pt_pt2_share_volume_month(inputs)
	if (locale === "fr-FR") return fr_fr2_share_volume_month(inputs)
	if (locale === "de-DE") return de_de2_share_volume_month(inputs)
	if (locale === "it-IT") return it_it2_share_volume_month(inputs)
	return en_us2_share_volume_month(inputs)
});
export { share_volume_month as "share.volume_month" }